import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  handleError(error: any): void {
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;
    const moduleScriptFailed = /Failed to load module script/;
    const mimeTypeError = /MIME type.*text\/html/;

    const errorMessage = error?.message || error?.toString() || '';

    if (
      chunkFailedMessage.test(errorMessage) ||
      moduleScriptFailed.test(errorMessage) ||
      mimeTypeError.test(errorMessage)
    ) {
      // Clear SW cache before reload
      if ('caches' in window) {
        caches.keys().then(names => names.forEach(name => caches.delete(name)));
      }
      location.reload();
      return;
    }

    console.error('Global error:', error);
  }
}
